export default __webpack_public_path__ + "static/media/pic17-1.82347749.jpg";